<template>
    <div>
  <v-card>
    <v-card-title>
        Withdrawal to Bank
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table :headers="headers" :items="upis">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.Autono }}</td>
        <td >{{ props.item.UpiId }}</td>
        <td >{{ props.item.User_Name }}</td>
        <td > <v-btn @click="withdraw(props.item)" small color="primary">Withdraw</v-btn></td>

      </template>
    </v-data-table>

  </v-card>
    <v-dialog v-model="proccess" persistent width="300">
            <v-card  color="primary" dark>
                <v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text>
            </v-card>
    </v-dialog>
  <v-dialog v-model="withdrawmodal"
                width="350" height="300">
                        <v-card >
                    <v-card-title>Enter Detail</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                    <v-text-field type="number" style="width:300px;margin:0 auto;height:60px;" label="Amount" v-model="amount" solo/>
                                    <v-text-field type="text" style="width:300px;margin:0 auto;height:60px;" label="Bank Account Name" v-model="accountname" solo/>
                                    <v-text-field type="text" style="width:300px;margin:0 auto;height:60px;" label="Remark" v-model="remark" solo/>
                                    <v-btn color="primary" @click="verify" style="width:300px;margin-left:10px">Validate</v-btn>
                            </v-card-text>
                    </v-card>
        </v-dialog>
  <v-dialog v-model="otpcheck"
                width="350" height="300">
                        <v-card >
                    <v-card-title>Enter OTP</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                    <v-text-field type="number" style="width:300px;margin:0 auto;height:60px;" label="Enter OTP" v-model="otp" solo/>
                                    <v-btn color="primary" @click="verifyotp" style="width:300px;margin-left:10px">SUBMIT</v-btn>
                            </v-card-text>
                        </v-card>
        </v-dialog>
      <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            proccess:false,
            dialog:false,
            headers: [
                { text: 'S No', value: 'sno',align: 'left'},
                { text: 'UPI ID', value: 'upi' },
                { text: 'Username', value: 'username' },
                { text: 'Action', value: 'action' },
            ],
            accountname:'',
            remark:'',
            amount:'',
            upis:[],
            upi:'',
            withdrawmodal:false,
            accountname:'',
            amount:'',
            remark:'',
            otp:'',
            upiname:'',
            otpcheck:false
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    mounted(){
        let vm = this;
        vm.getUPIID()
    },
    methods:{
        withdraw(item){
            let vm = this;
            vm.upiname = item.UpiId;
            vm.remark = ""
            vm.accountname = "";
            vm.amount = "";
            vm.otp = "";
            vm.withdrawmodal = true;
        },

        notification(type,message){
            this.$notify({
                    group: 'foo',
                    title: 'Important message',
                    text: message,
                    duration:5000,
                    type:type
            })
        },
        getUPIID(){
            let vm = this;
            let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json'
                }
            vm.$store.dispatch("axiospost",{
                    url:"GetList_Of_YesBankUPI_ID",
                    data:doc,
            }).then(function (res) {
                if(res.data.length!=0){
                    vm.upis = res.data
                }else{
                    vm.upis=[]
                }
            })

        },
        verify(){
            let vm = this;
            let upi = vm.upiname;
            if(vm.amount=="") return vm.notification("error","Amount Required!")
            if(vm.accountname=="") return vm.notification("error","Account Name Required!")
            vm.dialog = true;
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'Bank_Upi_Id':upi
                }
             vm.$store.dispatch("axiospost",{
                    url:"YesBank_Withdraw",
                    data:doc,
            }).then(function (res) {
                vm.dialog = false;
                let data = res.data;
                if(data.Status=="True"){
                    vm.withdrawmodal = false;
                    vm.otpcheck= true;
                    return vm.notification("success","OTP Send!")
                }
                return vm.notification("error",data.Message);
            }).catch(function (error) {
                vm.dialog = false;
                vm.notification("error",error.message)
            })
        },
         verifyotp(){
            let vm = this;
            if(vm.otp=="") return vm.notification("error","OTP Required!")
            vm.dialog = true;
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'Bank_Upi_Id':vm.upiname,
                'Otp':vm.otp,
                'Amount':vm.amount,
                'Account_Name':vm.accountname,
                'Remark':vm.remark
            }
            vm.$store.dispatch("axiospost",{
                    url:"YesBank_Verify_Withdraw_OTP",
                    data:doc,
            }).then(function (res) {
                let data = res.data;
                vm.dialog = false;
                vm.otpcheck = false;
                if(data.Status=="True"){
                    return vm.notification("success","Success!")
                }
                return vm.notification("error",data.Message);
            }).catch(function (error) {
                vm.notification("error",error.message)
            })
        }

    }
}
</script>
